import React from 'react';
import {Center} from '@chakra-ui/react';
import {Navigate, useParams} from 'react-router';
import {AllIntegrations} from './AllIntegrations';
import {useIntegration} from '../../hooks/api/integrations';
import {
  IntegrationType,
  isIntegrationType,
} from '../../shared/integrations/common';
import _ from 'lodash';
import {Title} from '../Title';
import {IntegrationProvider} from './IntegrationDetailsContext';
import {DelayedSpinner} from '../DelayedSpinner';
import {CrmIntegrationDetails} from './CrmIntegrationDetails';
import {LinkedInIntegrationDetails} from './LinkedInIntegrationDetails';
import {assertNever} from '../../shared/util';
import {SlackIntegrationDetails} from './SlackIntegrationDetails';
import {WebIntentIntegrationDetails} from './WebIntentIntegrationDetails';

export const IntegrationDetails = () => {
  const {integration} = useParams();

  if (!isIntegrationType(integration)) {
    return <Navigate to={'/settings/integrations'} />;
  }

  return (
    <Title title={AllIntegrations[integration].label}>
      <IntegrationDetails_ integrationType={integration} />
    </Title>
  );
};

const IntegrationDetails_ = ({
  integrationType,
}: {
  integrationType: IntegrationType;
}) => {
  const {data, isError, isPending} = useIntegration({type: integrationType});

  if (isError) {
    return <Navigate to={'/settings/integrations'} />;
  } else if (isPending) {
    return (
      <Center h="100%">
        <DelayedSpinner delayMs={100} />
      </Center>
    );
  }

  if (!data) {
    return <Navigate to={'/settings/integrations'} />;
  }

  let integrationDetails;
  switch (integrationType) {
    case 'hubspot':
    case 'salesforce':
      integrationDetails = <CrmIntegrationDetails />;
      break;
    case 'linkedin':
      integrationDetails = <LinkedInIntegrationDetails />;
      break;
    case 'slack':
      integrationDetails = <SlackIntegrationDetails />;
      break;
    case 'webIntent':
      integrationDetails = <WebIntentIntegrationDetails />;
      break;

    default:
      assertNever(integrationType);
  }

  return (
    <IntegrationProvider integrationResponse={data}>
      {integrationDetails}
    </IntegrationProvider>
  );
};
